class LOG {
    private static pool: Map<string, any> = new Map<string, any>();

    public static msg(e: any): Error 
    {
        log("ERROR!", e );
 
        return new Error(e);
    }

    public static log(...args: any) 
    {
        console.log(args);
    }

    public static error(...args: any) {
        console.log(args);
    }

    public static timer( int:number=1 )
    {
        let counter     : number = 0;

        //log( "Start "+ text );

        let interval = setInterval(() => {
            counter += int;
        }, int );

        function stop()
        {
            clearInterval( interval );

            return counter +"ms";
        }

        return stop;
 
    }
 


};

export var log = LOG.log;
export var error = LOG.error;
export var timer = LOG.timer;
export var print = LOG.log;

export default LOG;
